export default "__VITE_ASSET__Bhw8Yz1A__"